import {
  BILLING_STATUS,
  BILLING_TAB,
  NEW_TAB_TOOLTIP,
  PENDING_TAB_TOOLTIP,
  RECURRING_TAB_TOOLTIP,
} from 'components/TeamOverview/BillingSection/utilities/constants';
import { StatusLabel } from 'components/TeamOverview/BillingSection/components/StatusLabel';
import { BLUE, GREEN, ORANGE_2 } from 'utilities/colors';

export const StatusLabels = {
  [BILLING_TAB.NEW]: (
    <StatusLabel color={GREEN} text="Freemium" tooltip={NEW_TAB_TOOLTIP} />
  ),
  [BILLING_STATUS.PENDING]: (
    <StatusLabel
      color={ORANGE_2}
      text="Freemium Ending"
      tooltip={PENDING_TAB_TOOLTIP}
    />
  ),
  [BILLING_STATUS.PAID]: <StatusLabel color={GREEN} text="Paid" />,
  [BILLING_STATUS.RECURRING]: (
    <StatusLabel
      color={BLUE}
      text="In-Storage"
      tooltip={RECURRING_TAB_TOOLTIP}
    />
  ),
};

export const countBlocks = (blocks) =>
  blocks.reduce(
    (acc, item) => {
      acc.all += item.blocksCount;
      if (item.status === 'new') acc.freemium += item.blocksCount;
      if (item.status === 'pending') acc.pending += item.blocksCount;
      if (item.status === 'recurring') acc.inStorage += item.blocksCount;

      return acc;
    },
    {
      all: 0,
      freemium: 0,
      pending: 0,
      inStorage: 0,
    },
  );

export const parseUser = (user) => {
  const firstName = user.first_name || '';
  const lastName = user.last_name || '';

  if (!user.first_name && !user.last_name) {
    return '-';
  }

  return `${firstName} ${lastName}`;
};

export const groupBlocksByProject = (
  blocksBillings = [],
  filter = BILLING_TAB.ALL,
) => {
  const filteredBlocksBillings =
    filter === BILLING_TAB.ALL
      ? blocksBillings
      : blocksBillings.filter((blockBilling) => blockBilling.status === filter);

  const groupedOrders = new Map();

  filteredBlocksBillings.forEach((billing) => {
    const { project } = billing;
    if (!groupedOrders.has(project)) {
      groupedOrders.set(project, []);
    }
    groupedOrders.get(project).push(billing);
  });

  return groupedOrders;
};
